import axios from 'axios';

export default {
  getAll() {
    return axios.get('/v1/roi/mroi');
  },
  getIO(params = {}) {
    return axios.get('/v1/roi/search-io', { params });
  },
  amountCheck(params = {}) {
    return axios.get('/v1/roi/check-exceed', { params });
  },
  evaluate(dataROI) {
    return axios.patch('/v1/roi/evaluate', dataROI);
  }
};
